import cartConfigLogo from "../../assets/image/svg/cartConfig.svg";
import loginConfigLogo from "../../assets/image/svg/loginConfigLogo.svg";
import skuTileConfigLogo from "../../assets/image/svg/skuTileConfig.svg";
import checkoutConfigLogo from "../../assets/image/svg/checkoutConfig.svg";
import orderConfirmaionConfigLogo from "../../assets/image/svg/orderConfirmation.svg";
import orderTrackingConfigLogo from "../../assets/image/svg/orderTrackingConfig.svg";
import aiTaskConfigLogo from "../../assets/image/svg/aiTaskConfigLogo.svg";
import kpiConfigLogo from "../../assets/image/svg/kpiConfigLogo.svg";
import bannerConfigLogo from "../../assets/image/svg/bannerConfigLogo.svg";
import taskFilterConfigLogo from "../../assets/image/svg/taskFilterConfigLogo.svg";
import taskProgressDashboardConfigLogo from "../../assets/image/svg/taskProgressDashboardConfigLogo.svg";
import pjpConfigLogo from "../../assets/image/svg/pjpConfigLogo.svg";
import outletListConfigLogo from "../../assets/image/svg/outletListConfigLogo.svg";
import remoteOrderConfigLogo from "../../assets/image/svg/remoteOrderConfigLogo.svg";
import visitOrderConfigLogo from "../../assets/image/svg/visitOrderConfigLogo.svg";
import storeInOutConfigLogo from "../../assets/image/svg/uiThemeConfig.svg";
import recommendationConfigLogo from "../../assets/image/svg/uiThemeConfig.svg";
import outletTaskTileConfigLogo from "../../assets/image/svg/uiThemeConfig.svg";
import outletProfileConfigLogo from "../../assets/image/svg/outletProfileConfigLogo.svg";
import catalogFilterConfigLogo from "../../assets/image/svg/uiThemeConfig.svg";
import catalogueConfigLogo from "../../assets/image/svg/catalogueConfig.svg";
import oneClickOrderConfigLogo from "../../assets/image/svg/oneClickOrderConfigLogo.svg";
import attendanceConfigLogo from "../../assets/image/svg/uiThemeConfig.svg";
import orderFeedbackConfigLogo from "../../assets/image/svg/orderFeedbackConfigLogo.svg";
import supportConfigLogo from "../../assets/image/svg/uiThemeConfig.svg";
import incentiveConfigLogo from "../../assets/image/svg/incentiveConfigLogo.svg";
import teleOrderConfigLogo from "../../assets/image/svg/teleOrderConfigLogo.svg";
import competitionTrackingConfigLogo from "../../assets/image/svg/competitionTrackingConfigLogo.svg";
import merchandisingConfigLogo from "../../assets/image/svg/uiThemeConfig.svg";
import stockInventoryConfigLogo from "../../assets/image/svg/stockInventoryConfigLogo.svg";
import kpiHintImage from "../../assets/image/png/feautre-selection-bg.png";
import competetionTrackingImage from "../../assets/image/png/competetionTrackingLogo.png";
import incentiveImage from "../../assets/image/png/incentiveLogo.png";
import merchandisingImage from "../../assets/image/png/merchandisingLogo.png";
import recomendationImage from "../../assets/image/png/recomendationTaskLogo.png";
import stockInventoryImage from "../../assets/image/png/stockInventory.png";
import teleOrderImage from "../../assets/image/png/teleOrderLogo.png";
import uiThemeConfigLogo from "../../assets/image/svg/uiThemeConfig.svg";
import projectConfigLogo from "../../assets/image/svg/projectConfig.svg";

export const ImageIdToSVGMap: Record<string, string> = {
  uiThemeConfigLogo: uiThemeConfigLogo,
  projectConfigLogo: projectConfigLogo,
  incentiveConfigLogo: incentiveConfigLogo,
  teleOrderConfigLogo: teleOrderConfigLogo,
  competitionTrackingConfigLogo: competitionTrackingConfigLogo,
  merchandisingConfigLogo: merchandisingConfigLogo,
  stockInventoryConfigLogo: stockInventoryConfigLogo,
  kpiHintImage: kpiHintImage,
  cartConfigLogo: cartConfigLogo,
  loginConfigLogo: loginConfigLogo,
  skuTileConfigLogo: skuTileConfigLogo,
  checkoutConfigLogo: checkoutConfigLogo,
  orderConfirmaionConfigLogo: orderConfirmaionConfigLogo,
  orderTrackingConfigLogo: orderTrackingConfigLogo,
  aiTaskConfigLogo: aiTaskConfigLogo,
  kpiConfigLogo: kpiConfigLogo,
  bannerConfigLogo: bannerConfigLogo,
  taskFilterConfigLogo: taskFilterConfigLogo,
  taskProgressDashboardConfigLogo: taskProgressDashboardConfigLogo,
  pjpConfigLogo: pjpConfigLogo,
  outletListConfigLogo: outletListConfigLogo,
  remoteOrderConfigLogo: remoteOrderConfigLogo,
  visitOrderConfigLogo: visitOrderConfigLogo,
  storeInOutConfigLogo: storeInOutConfigLogo,
  recommendationConfigLogo: recommendationConfigLogo,
  outletTaskTileConfigLogo: outletTaskTileConfigLogo,
  outletProfileConfigLogo: outletProfileConfigLogo,
  catalogFilterConfigLogo: catalogFilterConfigLogo,
  catalogueConfigLogo: catalogueConfigLogo,
  oneClickOrderConfigLogo: oneClickOrderConfigLogo,
  attendanceConfigLogo: attendanceConfigLogo,
  orderFeedbackConfigLogo: orderFeedbackConfigLogo,
  supportConfigLogo: supportConfigLogo,
  incentiveImage: incentiveImage,
  teleOrderImage: teleOrderImage,
  competetionTrackingImage: competetionTrackingImage,
  merchandisingImage: merchandisingImage,
  recomendationImage: recomendationImage,
  stockInventoryImage: stockInventoryImage,
  default: uiThemeConfigLogo, // Fallback image
};

export const featureConfiguration = [
  {
    "id": "App essentials",
    "icon": "projectConfigLogo",
    "isDeveloped": true,
    "isActive": true,
    "isSelected": true,
    "isMandatory": true,
    "supportedAppTypes": [
      "sfa",
      "eb2b",
      "dms"
    ],
    "subfeatures": [
      {
        "id": "Project",
        "isDeveloped": true,
        "featureConfigName": "project",
        "isSelected": true,
        "domainMapping": {
          "clientconfig": [
            "customer_configuration",
            "app_configuration"
          ]
        },
        "appType": "standard",
        "supportedAppTypes": [
          "sfa",
          "eb2b",
          "dms"
        ],
        "configuration": [
          {
            "name": "lob",
            "domainType": "",
            "section": "Basic Configurations",
            "uiSchema": {
              "question": "LOB Name",
              "config": "custom",
              "displayType": "select",
              "vailidations": [],
              "dependsOn": {}
            }
          },
          {
            "name": "appName",
            "domainType": "app_configuration",
            "section": "Basic Configurations",
            "uiSchema": {
              "question": "App Name",
              "config": "json",
              "displayType": "textfield",
              "vailidations": [],
              "dependsOn": {}
            }
          },
          {
            "name": "countryCode",
            "section": "Basic Configurations",
            "domainType": "customer_configuration",
            "uiSchema": {
              "question": "Enter country code",
              "config": "custom",
              "displayType": "select",
              "validations": [],
              "dependsOn": {}
            }
          },
          {
            "name": "supportNumber",
            "section": "Basic Configurations",
            "domainType": "customer_configuration",
            "uiSchema": {
              "question": "Enter support number",
              "config": "json",
              "displayType": "textField",
              "validations": {
                "regex": "^.{10,15}$"
              },
              "dependsOn": {}
            }
          }
        ]
      },
      {
        "id": "UI and Theme",
        "isDeveloped": true,
        "featureConfigName": "uiandtheme",
        "icon": "uiThemeConfigLogo",
        "domainMapping": {
          "clientconfig": [
            "app_configuration",
            "theme_configuration"
          ]
        },
        "isActive": false,
        "isSelected": true,
        "isMandatory": true,
        "hintImage": "kpiHintImage",
        "displayTemplateTwo": true,
        "role": [
          "salesrep",
          "retailer"
        ],
        "appType": "standard",
        "supportedAppTypes": [
          "sfa",
          "eb2b",
          "dms"
        ],
        "configuration": [
          {
            "name": "clientLogo",
            "section": "Branding & Identity",
            "domainType": "app_configuration",
            "uiSchema": {
              "question": "Upload brand logo",
              "config": "json",
              "displayType": "image",
              "validations": {
                "height": 512,
                "width": 512,
                "max": true
              }
            }
          },
          {
            "name": "clientLogoHeight",
            "section": "Branding & Identity",
            "domainType": "app_configuration",
            "uiSchema": {
              "question": "Enter brand logo height (px)",
              "config": "json",
              "displayType": "textfield",
              "validations": {
                "regex": "^[1-9]\\d*$"
              }
            }
          },
          {
            "name": "clientHeaderLogo",
            "section": "Branding & Identity",
            "domainType": "app_configuration",
            "uiSchema": {
              "question": "Upload header logo",
              "config": "json",
              "displayType": "image",
              "validations": {
                "height": 512,
                "width": 512,
                "max": true
              }
            }
          },
          {
            "name": "clientHeaderLogoHeight",
            "section": "Branding & Identity",
            "domainType": "app_configuration",
            "uiSchema": {
              "question": "Enter header logo height (px)",
              "config": "json",
              "displayType": "textfield",
              "validations": {
                "textType": "number"
              }
            }
          },
          {
            "name": "appIcon",
            "section": "Branding & Identity",
            "domainType": "app_configuration",
            "uiSchema": {
              "question": "Upload app icon",
              "config": "json",
              "displayType": "image",
              "validations": {
                "height": 512,
                "width": 512,
                "max": true
              }
            }
          },
          {
            "name": "loginBanner",
            "section": "Branding & Identity",
            "domainType": "app_configuration",
            "uiSchema": {
              "question": "Upload login banners",
              "config": "json",
              "displayType": "image",
              "validations": {
                "height": 540,
                "width": 720,
                "max": true
              }
            }
          },
          {
            "name": "moreScreenLogo",
            "section": "Branding & Identity",
            "domainType": "app_configuration",
            "uiSchema": {
              "question": "Upload More/About screen logo",
              "config": "json",
              "displayType": "image",
              "validations": {
                "height": 512,
                "width": 512,
                "max": true
              }
            }
          },
          {
            "name": "appBarBackgroundType",
            "section": "App Bar & Theme",
            "domainType": "app_configuration",
            "uiSchema": {
              "question": "Select app bar background type",
              "config": "custom",
              "displayType": "select",
              "editable": true,
              "validations": {
                "options": [
                  "solid",
                  "gradient",
                  "image"
                ]
              }
            }
          },
          {
            "name": "themeColor",
            "section": "App Bar & Theme",
            "domainType": "app_configuration",
            "uiSchema": {
              "question": "Pick primary theme color",
              "config": "json",
              "displayType": "colorInput",
              "validations": {}
            }
          },
          {
            "name": "themeBackGroundColor",
            "section": "App Bar & Theme",
            "domainType": "theme_configuration",
            "uiSchema": {
              "question": "Pick background color",
              "config": "json",
              "displayType": "colorInput",
              "validations": {}
            }
          },
          {
            "name": "themeDisabledButtonColor",
            "section": "App Bar & Theme",
            "domainType": "theme_configuration",
            "uiSchema": {
              "question": "Pick disabled button color",
              "config": "json",
              "displayType": "colorInput",
              "validations": {}
            }
          },
          {
            "name": "activeLanguageColor",
            "section": "App Bar & Theme",
            "domainType": "theme_configuration",
            "uiSchema": {
              "question": "Pick active language color",
              "config": "json",
              "displayType": "colorInput",
              "validations": {}
            }
          }
        ]
      },
      {
        "id": "Authentication",
        "isDeveloped": true,
        "icon": "loginConfigLogo",
        "domainMapping": {
          "clientconfig": [
            "authentication_configuration",
            "password_configuration"
          ]
        },
        "isActive": false,
        "isSelected": true,
        "isMandatory": true,
        "hintImage": "kpiHintImage",
        "featureConfigName": "login",
        "role": [
          "salesrep",
          "retailer"
        ],
        "supportedAppTypes": [
          "sfa",
          "eb2b",
          "dms"
        ],
        "configuration": [
          {
            "name": "loginType",
            "section": "Login Configurations",
            "domainType": "authentication_configuration",
            "uiSchema": {
              "question": "Choose the primary sign-in method",
              "config": "json",
              "displayType": "select",
              "validations": {
                "options": [
                  "password",
                  "otp",
                  "otpAndPassword"
                ]
              }
            }
          },
          {
            "name": "deviceUID",
            "section": "Login Configurations",
            "domainType": "authentication_configuration",
            "uiSchema": {
              "question": "Show device UID on login?",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "deviceUidValidation",
            "section": "Login Configurations",
            "domainType": "authentication_configuration",
            "uiSchema": {
              "question": "Validate device UID mapping?",
              "config": "json",
              "displayType": "toggle",
              "editable": true,
              "validations": []
            }
          },
          {
            "name": "termsChecked",
            "section": "Login Configurations",
            "domainType": "authentication_configuration",
            "uiSchema": {
              "question": "Terms & Conditions required?",
              "config": "json",
              "displayType": "toggle",
              "editable": true,
              "validations": []
            }
          },
          {
            "name": "otpProvider",
            "section": "Login Configurations",
            "domainType": "authentication_configuration",
            "uiSchema": {
              "question": "OTP provider",
              "description": "Select provider responsible for OTP generation/validation.",
              "config": "json",
              "displayType": "select",
              "dependsOn": {
                "loginType": "otp"
              },
              "validations": {
                "options": [
                  "vonage",
                  "other"
                ]
              }
            }
          },
          {
            "name": "otpType",
            "section": "Login Configurations",
            "domainType": "authentication_configuration",
            "uiSchema": {
              "question": "OTP Type",
              "description": "Choose where the user receives OTP.",
              "config": "json",
              "displayType": "select",
              "dependsOn": {
                "loginType": "otp"
              },
              "validations": {
                "options": [
                  "sms",
                  "smsAndWhatsapp"
                ]
              }
            }
          },
          {
            "name": "otpLength",
            "section": "Login Configurations",
            "domainType": "authentication_configuration",
            "uiSchema": {
              "question": "OTP length (digits)",
              "description": "Set the number of digits for the OTP.",
              "config": "json",
              "displayType": "textfield",
              "dependsOn": {
                "loginType": "otp"
              },
              "validations": {
                "min": 4,
                "max": 10
              }
            }
          },
          {
            "name": "otpDisclaimer",
            "section": "Login Configurations",
            "domainType": "authentication_configuration",
            "uiSchema": {
              "question": "OTP Disclaimer",
              "description": "Message shown on OTP page (max ~30 chars).",
              "config": "json",
              "displayType": "textfield",
              "dependsOn": {
                "loginType": "otp"
              },
              "validations": {
                "maxLength": 30
              }
            }
          },
          {
            "name": "phoneNumberMaximumLength",
            "section": "Login Configurations",
            "domainType": "authentication_configuration",
            "uiSchema": {
              "question": "Phone number — maximum length",
              "description": "Max digits allowed for phone input.",
              "config": "json",
              "displayType": "textfiled",
              "dependsOn": {
                "loginType": "otp"
              },
              "validations": {
                "min": 1,
                "max": 20
              }
            }
          },
          {
            "name": "phoneNumberMinimumLength",
            "section": "Login Configurations",
            "domainType": "authentication_configuration",
            "uiSchema": {
              "question": "Phone number — minimum length",
              "description": "Min digits required for phone input.",
              "config": "json",
              "dependsOn": {
                "loginType": "otp"
              },
              "displayType": "textfield",
              "validations": {
                "min": 1,
                "max": 20
              }
            }
          },
          {
            "name": "captureLocationAfterLogin",
            "section": "Login Configurations",
            "domainType": "authentication_configuration",
            "uiSchema": {
              "question": "Capture location after login?",
              "description": "Prompt for location permission immediately after login.",
              "config": "json",
              "dependsOn": {
                "loginType": "otp"
              },
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "passwordComplexity",
            "section": "Password Complexity",
            "domainType": "password_configuration",
            "uiSchema": {
              "question": "Capture location after login?",
              "description": "Prompt for location permission immediately after login.",
              "config": "custom",
              "displayType": "custom",
              "validations": {}
            }
          },
          {
            "name": "userLoginBlock",
            "section": "Password Retry and Lockout",
            "domainType": "password_configuration",
            "uiSchema": {
              "question": "Capture location after login?",
              "description": "Prompt for location permission immediately after login.",
              "config": "custom",
              "displayType": "custom",
              "validations": {}
            }
          },
          {
            "name": "userInactivityBlock",
            "section": "Deactive Inactive Users",
            "domainType": "password_configuration",
            "uiSchema": {
              "question": "Capture location after login?",
              "description": "Prompt for location permission immediately after login.",
              "config": "custom",
              "displayType": "custom",
              "validations": {}
            }
          }
        ]
      }
    ]
  },
  {
    "id": "Must Do Action",
    "isDeveloped": true,
    "icon": "teleOrderConfigLogo",
    "description": "Manage the sequence and messaging of must do task.",
    "isActive": false,
    "isSelected": true,
    "isMandatory": true,
    "hintImage": "teleOrderImage",
    "featureConfigName": "mustdoaction",
    "role": [
      "salesrep"
    ],
    "supportedAppTypes": [
      "sfa",
      "eb2b",
      "dms"
    ],
    "subfeatures": [
      {
        "id": "Must Do Action",
        "isVisible": true,
        "isSelected": true,
        "isActive": false,
        "isMandatory": true,
        "hintImage": "teleOrderImage",
        "featureConfigName": "mustdoaction",
        "isDeveloped": true,
        "domainMapping": {
          "clientconfig": [
            "must_do_action_configuration"
          ]
        },
        "configuration": [
          {
            "name": "mustDoActionCard",
            "domainType": "must_do_action_card_configuration",
            "uiSchema": {
              "question": "list of must do actions",
              "config": "custom",
              "displayType": "multipleCheckbox",
              "validations": []
            }
          },
          {
            "name": "outletTabFilters",
            "domainType": "outlet_tab_filters_configuration",
            "uiSchema": {
              "question": "list of outlet Tab Filters",
              "config": "custom",
              "displayType": "multipleCheckbox",
              "validations": []
            }
          },
          {
            "name": "focusProductsLabel",
            "domainType": "focus_products_label_configuration",
            "uiSchema": {
              "question": "focus products label",
              "config": "json",
              "displayType": "textfield",
              "validations": []
            }
          },
          {
            "name": "liveUpdateLabel",
            "domainType": "live_update_label_configuration",
            "uiSchema": {
              "question": "live update label",
              "config": "json",
              "displayType": "textfield",
              "validations": []
            }
          },
          {
            "name": "premiumProductsLabel",
            "domainType": "premium_products_label_configuration",
            "uiSchema": {
              "question": "premium products label",
              "config": "json",
              "displayType": "textfield",
              "validations": []
            }
          }
        ]
      }
    ]
  },
  {
    "id": "KPI Review",
    "isDeveloped": true,
    "icon": "kpiConfigLogo",
    "description": "Select and modify KPIs you want to show to your Sales team.",
    "isActive": false,
    "isSelected": true,
    "isMandatory": true,
    "hintImage": "kpiHintImage",
    "featureConfigName": "kpi",
    "role": [
      "salesrep"
    ],
    "supportedAppTypes": [
      "sfa",
      "eb2b",
      "dms"
    ],
    "subfeatures": [
      {
        "id": "KPI review",
        "isVisible": true,
        "isSelected": true,
        "isActive": false,
        "isMandatory": true,
        "hintImage": "teleOrderImage",
        "featureConfigName": "mustdoaction",
        "isDeveloped": true,
        "domainMapping": {
          "clientconfig": [
            "kpi_configuration"
          ]
        },
        "configurations": []
      }
    ]
  },
  {
    "id": "Catalogue",
    "isDeveloped": true,
    "icon": "catalogueConfigLogo",
    "description": "Manage the product catalogue to make the ordering process more efficient.",
    "isActive": false,
    "isSelected": true,
    "isMandatory": true,
    "featureConfigName": "catalogue",
    "hintImage": "kpiHintImage",
    "role": [
      "salesrep",
      "retailer"
    ],
    "supportedAppTypes": [
      "sfa",
      "eb2b",
      "dms"
    ],
    "subfeatures": [
      {
        "id": "Catalogue",
        "isVisible": true,
        "isActive": true,
        "isMandatory": true,
        "isSelected": true,
        "isDeveloped": true,
        "appType": "standard",
        "domainMapping": {
          "clientconfig": [
            "catalogue_configuration",
            "tab_filters"
          ]
        },
        "hintImage": "kpiHintImage",
        "featureConfigName": "ordersummary",
        "configuration": [
          {
            "name": "catalogue",
            "section": "Catalogue Filter",
            "domainType": "catalogue_configuration",
            "uiSchema": {
              "question": "Display Product Validation",
              "config": "custom",
              "displayType": "custom",
              "validations": []
            }
          },
          {
            "name": "Dummy Image Upload",
            "section": "Dummy Image Upload",
            "domainType": "catalogue_configuration",
            "uiSchema": {
              "question": "Display Product Validation",
              "config": "custom",
              "displayType": "custom",
              "validations": []
            }
          },
          {
            "name": "Labels",
            "section": "Labels",
            "domainType": "catalogue_configuration",
            "uiSchema": {
              "question": "Display Product Validation",
              "config": "custom",
              "displayType": "custom",
              "validations": []
            }
          },
          {
            "name": "showSkuCode",
            "section": "SKU tile",
            "domainType": "catalogue_configuration",
            "uiSchema": {
              "question": "Display Product Validation",
              "config": "custom",
              "displayType": "custom",
              "validations": []
            }
          },
          {
            "name": "Similar Product",
            "section": "Similar Product Grouping & price format",
            "domainType": "catalogue_configuration",
            "uiSchema": {
              "question": "Display Product Validation",
              "config": "custom",
              "displayType": "custom",
              "validations": []
            }
          },
          {
            "name": "priceFormatter",
            "section": "Similar Product Grouping & price format",
            "domainType": "catalogue_configuration",
            "uiSchema": {
              "question": "Price Formatter",
              "config": "custom",
              "displayType": "textfield",
              "validations": [
                {
                  "type": "string",
                  "minLength": 1,
                  "maxLength": 50
                }
              ]
            }
          },
          {
            "name": "displayProductValidation",
            "domainType": "catalogue_configuration",
            "uiSchema": {
              "question": "Display Product Validation",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "productTypeFilter",
            "domainType": "catalogue_configuration",
            "uiSchema": {
              "question": "Product Type Filter",
              "config": "json",
              "displayType": "textfield",
              "validations": []
            }
          },
          {
            "name": "displayProductValidationFilter",
            "domainType": "catalogue_configuration",
            "uiSchema": {
              "question": "Display Product Validation Filter",
              "config": "json",
              "displayType": "textfield",
              "validations": []
            }
          },
          {
            "name": "sspLabel",
            "domainType": "catalogue_configuration",
            "uiSchema": {
              "question": "SSP Label",
              "config": "json",
              "displayType": "textfield",
              "validations": [
                {
                  "type": "string",
                  "minLength": 1,
                  "maxLength": 30
                }
              ]
            }
          },
          {
            "name": "defaultQtyForOrder",
            "domainType": "catalogue_configuration",
            "uiSchema": {
              "question": "Default Quantity For Order",
              "config": "json",
              "displayType": "textfield",
              "validations": [
                {
                  "type": "number",
                  "min": 1
                }
              ]
            }
          },
          {
            "name": "editPricing",
            "domainType": "catalogue_configuration",
            "uiSchema": {
              "question": "Edit Pricing",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "outletLevelPricing",
            "domainType": "catalogue_configuration",
            "uiSchema": {
              "question": "Outlet Level Pricing",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "enableEditPrice",
            "domainType": "catalogue_configuration",
            "uiSchema": {
              "question": "Enable Edit Price",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          }
        ]
      }
    ]
  },
  {
    "id": "Order",
    "isDeveloped": true,
    "icon": "checkoutConfigLogo",
    "description": "Manage what the user sees before order submission.",
    "isActive": false,
    "isSelected": true,
    "isMandatory": true,
    "hintImage": "kpiHintImage",
    "featureConfigName": "ordersummary",
    "role": [
      "salesrep",
      "retailer"
    ],
    "supportedAppTypes": [
      "sfa",
      "eb2b",
      "dms"
    ],
    "subfeatures": [
      {
        "id": "Order Summary",
        "isVisible": true,
        "isActive": true,
        "isMandatory": true,
        "isSelected": true,
        "isDeveloped": true,
        "domainMapping": {
          "clientconfig": [
            "order_configuration"
          ]
        },
        "appType": "standard",
        "hintImage": "kpiHintImage",
        "featureConfigName": "ordersummary",
        "configuration": [
          {
            "name": "distributorVisibility",
            "domainType": "order_configuration",
            "uiSchema": {
              "question": "Visibility of Distributor/Supplier details in order checkout details",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "orderDSIdVisibility",
            "domainType": "order_configuration",
            "uiSchema": {
              "question": "to show distributor id",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "orderTncLink",
            "domainType": "order_configuration",
            "uiSchema": {
              "question": "Upload orderTncLink",
              "config": "custom",
              "displayType": "file",
              "validations": []
            }
          },
          {
            "name": "orderRemarksVisibility",
            "domainType": "order_configuration",
            "uiSchema": {
              "question": "To show order remarks input in order summary.",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "wholeSalerMarginVisibility",
            "domainType": "order_configuration",
            "uiSchema": {
              "question": "to show wholesaler margin",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "retailerMarginVisibility",
            "domainType": "order_configuration",
            "uiSchema": {
              "question": "Visibility of Distributor/Supplier details in order checkout details",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "locationPopupOnOrder",
            "domainType": "order_configuration",
            "uiSchema": {
              "question": "Location Capture while order placement",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "orderTncVisibility",
            "domainType": "order_configuration",
            "uiSchema": {
              "question": "Term & Condition",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "orderConfirmationPopup",
            "domainType": "order_configuration",
            "uiSchema": {
              "question": "order confirmation popup",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "orderSummaryDisclaimer",
            "domainType": "order_configuration",
            "uiSchema": {
              "question": "order summary disclaimer",
              "config": "json",
              "displayType": "textfieldList",
              "validations": []
            }
          },
          {
            "name": "orderInvoiceDisclaimer",
            "domainType": "order_configuration",
            "uiSchema": {
              "question": "order invoice disclaimer",
              "config": "json",
              "displayType": "textfieldList",
              "validations": []
            }
          },
          {
            "name": "orderCheckoutTotalAmountLabel",
            "domainType": "order_configuration",
            "uiSchema": {
              "question": "Label for Total Amount in order summary page.",
              "config": "json",
              "displayType": "textfield",
              "validations": []
            }
          },
          {
            "name": "orderCheckoutDiscountLabel",
            "domainType": "order_configuration",
            "uiSchema": {
              "question": "Label for discount in order summary page.",
              "config": "json",
              "displayType": "textfield",
              "validations": []
            }
          },
          {
            "name": "orderSubmitButtonLabel",
            "domainType": "order_configuration",
            "uiSchema": {
              "question": "Label for submit button in order summary page.",
              "config": "json",
              "displayType": "textfield",
              "validations": []
            }
          },
          {
            "name": "orderCheckoutFinalAmountLabel",
            "domainType": "order_configuration",
            "uiSchema": {
              "question": "Label for checkoutTotal in order summary page.",
              "config": "json",
              "displayType": "textfield",
              "validations": []
            }
          }
        ]
      },
      {
        "id": "Order Tracking",
        "isVisible": true,
        "isActive": true,
        "isMandatory": true,
        "isSelected": true,
        "isDeveloped": true,
        "domainMapping": {
          "clientconfig": [
            "order_configuration"
          ]
        },
        "appType": "standard",
        "hintImage": "kpiHintImage",
        "featureConfigName": "ordersummary",
        "configuration": [
          {
            "name": "orderTrackingStages",
            "domainType": "order_configuration",
            "section": "Manage Order Tracking",
            "uiSchema": {
              "question": "Order tracking stages",
              "config": "custom",
              "displayType": "multipleCheckbox",
              "validations": []
            }
          },
          {
            "name": "reOrder",
            "domainType": "order_configuration",
            "uiSchema": {
              "question": "Enable Re-order option for past orders",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "orderTrackingInvoiceTabVisibility",
            "domainType": "order_configuration",
            "uiSchema": {
              "question": "Show Invoice Tab in Order Tracking",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "dmsSpecificOrderTrackingSummary",
            "domainType": "order_configuration",
            "uiSchema": {
              "question": "Enable DMS-specific Order Tracking Summary",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "editOrder",
            "domainType": "order_configuration",
            "uiSchema": {
              "question": "Allow editing orders after submission",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "rejectOrder",
            "domainType": "order_configuration",
            "uiSchema": {
              "question": "Allow rejecting orders",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "deleteOrder",
            "domainType": "order_configuration",
            "uiSchema": {
              "question": "Allow deleting orders",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          }
        ]
      },
      {
        "id": "Cart",
        "isVisible": true,
        "isActive": true,
        "isMandatory": true,
        "isSelected": true,
        "isDeveloped": true,
        "domainMapping": {
          "clientconfig": [
            "order_configuration"
          ]
        },
        "appType": "standard",
        "hintImage": "kpiHintImage",
        "featureConfigName": "ordersummary",
        "configuration": [
          {
            "name": "fullFilledByLabel",
            "domainType": "order_configuration",
            "uiSchema": {
              "question": "Fulfilled By Label",
              "config": "json",
              "displayType": "textfield",
              "editable": true,
              "validations": [
                {
                  "type": "string",
                  "minLength": 3,
                  "maxLength": 50
                }
              ]
            }
          },
          {
            "name": "persistentCartNavigationBar",
            "domainType": "order_configuration",
            "uiSchema": {
              "question": "Enable Persistent Cart Navigation Bar",
              "config": "json",
              "displayType": "toggle",
              "validations": []
            }
          },
          {
            "name": "cart",
            "domainType": "order_configuration",
            "uiSchema": {
              "question": "Enable Persistent Cart Navigation Bar",
              "config": "custom",
              "displayType": "custom",
              "validations": []
            }
          }
        ]
      }
    ]
  },
  {
    "id": "PJP",
    "isDeveloped": true,
    "icon": "pjpConfigLogo",
    "description": "Manage outlet activities and PJP settings for the user.",
    "isActive": true,
    "isSelected": true,
    "isMandatory": true,
    "featureConfigName": "pjp",
    "role": [
      "salesrep",
      "retailer"
    ],
    "supportedAppTypes": [
      "sfa",
      "eb2b",
      "dms"
    ],
    "subfeatures": [
      {
        "id": "Outlet List",
        "isVisible": true,
        "isActive": true,
        "isMandatory": true,
        "isSelected": true,
        "isDeveloped": true,
        "domainMapping": {
          "clientconfig": [
            "outlet_activity_configuration",
            "target_configuration"
          ]
        },
        "appType": "standard",
        "featureConfigName": "pjp",
        "hintImage": "pjpHintImage",
        "configuration": [
          {
            "name": "outletScreenWidget",
            "domainType": "app_layout_configuration",
            "uiSchema": {
              "question": "Add Outlet screen widgets to outlet screen",
              "config": "custom",
              "displayType": "checkbox"
            }
          },
          {
            "name": "outletTileOptions",
            "domainType": "app_layout_configuration",
            "uiSchema": {
              "question": "Controls quick actions on the tile (Remote/Tele/Visit Order)",
              "config": "custom",
              "displayType": "table"
            }
          },
          {
            "name": "outletTabFilters",
            "domainType": "must_do_action_configuration",
            "uiSchema": {
              "question": "Control visibility of tabs (Sales Target, Must Order, Focus) on the Outlet screen",
              "config": "custom",
              "displayType": "table"
            }
          },
          {
            "name": "outletCodeVisibility",
            "section": "Card Content & Badges",
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Show outlet code on card?",
              "config": "json",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "billedTagVisibility",
            "section": "Card Content & Badges",
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Show billed tag (monthly)?",
              "config": "json",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "additionalOutletTagVisibility",
            "section": "Card Content & Badges",
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Show additional outlet tag?",
              "config": "json",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "outletCategoryVisibility",
            "section": "Card Content & Badges",
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Show outlet category on card?",
              "config": "json",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "marketIdVisibility",
            "section": "Card Content & Badges",
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Show Market ID on card?",
              "config": "json",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "outletTypeVisibility",
            "section": "Card Content & Badges",
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Show outlet type on card?",
              "config": "json",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "lastVisitDateVisibility",
            "section": "Card Content & Badges",
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Show last visit date on card?",
              "config": "json",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "outletClassBadge",
            "section": "Card Content & Badges",
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Show outlet class badge?",
              "config": "json",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "outletSortingTemplate",
            "section": "Sorting & Sequence",
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Outlet sorting template",
              "config": "json",
              "displayType": "select",
              "validations": {
                "options": [
                  "location",
                  "outletSequence"
                ]
              }
            }
          },
          {
            "name": "sequencedOutletVisitFlag",
            "section": "Sorting & Sequence",
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Sequenced outlet visit required?",
              "config": "json",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "blockOutletActivityForOutOfRange",
            "section": "Visit Flow & Access Control",
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Block outlet activity if out of range?",
              "config": "json",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "blockOutletActivityOnLeave",
            "section": "Visit Flow & Access Control",
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Block outlet activity on leave?",
              "config": "json",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "blockVisitFlow",
            "section": "Visit Flow & Access Control",
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Enable outlet visit flow?",
              "config": "json",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "targetType",
            "section": "Targets & Metrics",
            "domainType": "target_configuration",
            "uiSchema": {
              "question": "Sales Target - Value/Volume?",
              "config": "json",
              "displayType": "select",
              "validations": {
                "options": [
                  "value",
                  "volume"
                ]
              }
            }
          }
        ]
      },
      {
        "id": "Map and Geo-Fencing",
        "isVisible": true,
        "isActive": true,
        "isMandatory": true,
        "isSelected": true,
        "isDeveloped": true,
        "domainMapping": {
          "clientconfig": [
            "outlet_activity_configuration"
          ]
        },
        "appType": "standard",
        "featureConfigName": "pjp",
        "hintImage": "pjpHintImage",
        "configuration": [
          {
            "name": "zoomMapToCurrentOutlet",
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Zoom map to current outlet",
              "config": "json",
              "displayType": "toggle"
            }
          },
          {
            "name": "outletDistanceVisibility",
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Show distance to outlet on card",
              "config": "json",
              "displayType": "toggle"
            }
          },
          {
            "name": "outletNavigation",
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Show outlet navigation on card",
              "config": "json",
              "displayType": "toggle"
            }
          },
          {
            "name": "geolocationPopupVisibility",
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Show geolocation popup",
              "config": "json",
              "displayType": "toggle"
            }
          },
          {
            "name": "storeInRange",
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Allowed store-in range (meters)",
              "config": "json",
              "displayType": "textfield",
              "validations": {
                "textType": "number"
              }
            }
          },
          {
            "name": "distanceFilterForLocation",
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Re-fetch distance after (meters)",
              "config": "json",
              "displayType": "textfield",
              "validations": {}
            }
          }
        ]
      },
      {
        "id": "PJP and Beat",
        "isVisible": true,
        "isActive": true,
        "isMandatory": true,
        "isSelected": true,
        "isDeveloped": true,
        "domainMapping": {
          "clientconfig": [
            "outlet_activity_configuration"
          ]
        },
        "appType": "standard",
        "featureConfigName": "pjp",
        "hintImage": "pjpHintImage",
        "configuration": [
          {
            "name": "pjpLabel",
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Enable PJP Toggle",
              "config": "json",
              "displayType": "textfield"
            }
          },
          {
            "name": "pjpBeatVisibility",
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Show PJP/Beat info on card",
              "config": "json",
              "displayType": "toggle"
            }
          },
          {
            "name": "pjpBannerVisibility",
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Show PJP banner",
              "config": "json",
              "displayType": "toggle"
            }
          },
          {
            "name": "deviatePjp",
            "domainType": "outlet_activity_configuration",
            "uiSchema": {
              "question": "Deviate PJP flag (app bar)",
              "config": "json",
              "displayType": "toggle"
            }
          }
        ]
      },
      {
        "id": "OutletMapping",
        "isVisible": true,
        "isActive": true,
        "isMandatory": true,
        "isSelected": true,
        "isDeveloped": true,
        "domainMapping": {
          "clientconfig": [
            "outlet_mapping"
          ]
        },
        "appType": "standard",
        "featureConfigName": "outletmapping",
        "hintImage": "outletMappingHintImage",
        "configuration": [
          {
            "name": "enableOutletMapping",
            "domainType": "outlet_mapping",
            "uiSchema": {
              "question": "Enable Outlet Mapping?",
              "config": "json",
              "displayType": "toggle",
              "description": "If Yes, then Outlet Mapping feature will be available to all users."
            }
          },
          {
            "name": "outletMappingTabs",
            "domainType": "outlet_mapping",
            "uiSchema": {
              "question": "Outlet Mapping Tabs",
              "config": "custom",
              "displayType": "checkbox",
              "description": "Choose which tabs are visible to users. (Checked tabs will be visible)",
              "validations": {
                "options": [
                  "Existing",
                  "New"
                ]
              }
            }
          },
          {
            "name": "cleanOutletMappingData",
            "domainType": "outlet_mapping",
            "uiSchema": {
              "question": "Clean Outlet Mapping Data",
              "config": "custom",
              "displayType": "list",
              "description": "Keys to retain/clean in payload."
            }
          },
          {
            "name": "immediateParentTemplate",
            "domainType": "outlet_mapping",
            "uiSchema": {
              "question": "Immediate Parent Template",
              "config": "json",
              "displayType": "textfield",
              "description": "How parent mapping is resolved."
            }
          },
          {
            "name": "featureConnectionType",
            "domainType": "outlet_mapping",
            "uiSchema": {
              "question": "Feature Connection Type",
              "config": "json",
              "displayType": "textfield",
              "description": "Connectivity mode for this feature."
            }
          },
          {
            "name": "outletMappingSyncInfo",
            "domainType": "outlet_mapping",
            "uiSchema": {
              "question": "Outlet Mapping Sync",
              "config": "custom",
              "displayType": "table",
              "description": "Sync source per tab."
            }
          },
          {
            "name": "getSubChannelApi",
            "domainType": "outlet_mapping",
            "uiSchema": {
              "question": "GET Sub Channel API",
              "config": "json",
              "displayType": "select",
              "description": "API param to fetch sub-channel or channel from outletCategory.",
              "validations": {
                "options": [
                  "subChannel",
                  "channel"
                ]
              }
            }
          },
          {
            "name": "showActivityStatusTags",
            "domainType": "outlet_mapping",
            "uiSchema": {
              "question": "Show Activity Status Tags",
              "config": "json",
              "displayType": "toggle",
              "description": "Show activity status tags on outlet cards."
            }
          },
          {
            "name": "outletCodeTemplate",
            "domainType": "outlet_mapping",
            "uiSchema": {
              "question": "Outlet Code Template",
              "config": "json",
              "displayType": "textfield",
              "description": "Pattern used to generate outlet codes."
            }
          },
          {
            "name": "customerChannelDistributorMapping",
            "domainType": "outlet_mapping",
            "uiSchema": {
              "question": "Customer Channel Distributor Mapping",
              "config": "custom",
              "displayType": "map",
              "description": "Auto-map customer sub-category to distributor type."
            }
          },
          {
            "name": "locationKeyMap",
            "domainType": "outlet_mapping",
            "uiSchema": {
              "question": "Location Key Map",
              "config": "custom",
              "displayType": "jsonviewer",
              "description": "Form field → location key mapping."
            }
          },
          {
            "name": "updateOutletDetailsFromRequestBody",
            "domainType": "outlet_mapping",
            "uiSchema": {
              "question": "Update Outlet Details from Request Body",
              "config": "json",
              "displayType": "toggle",
              "description": "Update outlet from request body (vs response)."
            }
          },
          {
            "name": "updateLocationOnImageCapture",
            "domainType": "outlet_mapping",
            "uiSchema": {
              "question": "Update Location on Image Capture",
              "config": "json",
              "displayType": "toggle",
              "description": "Refresh lat/long when a photo is captured."
            }
          }
        ]
      }
    ]
  },
  {
    "id": "Attendance",
    "isDeveloped": true,
    "icon": "attendanceConfigLogo",
    "description": "Manage attendance settings for sales reps.",
    "isActive": true,
    "isSelected": true,
    "isMandatory": true,
    "featureConfigName": "attendance",
    "role": [
      "salesrep"
    ],
    "supportedAppTypes": [
      "sfa",
      "dms"
    ],
    "subfeatures": [
      {
        "id": "Attendance",
        "isVisible": true,
        "isActive": true,
        "isMandatory": true,
        "isSelected": true,
        "isDeveloped": true,
        "domainMapping": {
          "clientconfig": [
            "attendance_configuration"
          ]
        },
        "appType": "standard",
        "featureConfigName": "attendance",
        "hintImage": "attendanceHintImage",
        "configuration": [
          {
            "name": "isAttendanceMandatory",
            "domainType": "attendance_configuration",
            "uiSchema": {
              "question": "Make attendance mandatory for sales reps?",
              "config": "json",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "attendanceStatusOption",
            "domainType": "attendance_configuration",
            "uiSchema": {
              "question": "Attendance status options",
              "config": "custom",
              "displayType": "table"
            }
          },
          {
            "name": "requirePhotoForAttendance",
            "domainType": "attendance_configuration",
            "uiSchema": {
              "question": "Require photo for attendance?",
              "config": "json",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "attendanceLocationPopup",
            "domainType": "attendance_configuration",
            "uiSchema": {
              "question": "Show attendance location popup before marking?",
              "config": "json",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "attendanceRange",
            "domainType": "attendance_configuration",
            "uiSchema": {
              "question": "Attendance range for outlet (meters)",
              "config": "json",
              "displayType": "textfield",
              "validations": {
                "textType": "number"
              },
              "dependsOn": {
                "attendanceLocationPopup": true
              }
            }
          },
          {
            "name": "blockOutletActivityOnLeave",
            "domainType": "attendance_configuration",
            "uiSchema": {
              "question": "Block outlet activity on leave?",
              "config": "json",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "checkAttendanceOnMustDoAction",
            "domainType": "attendance_configuration",
            "uiSchema": {
              "question": "Check attendance on Must Do Actions?",
              "config": "json",
              "displayType": "toggle",
              "validations": {}
            }
          }
        ]
      }
    ]
  },
  {
    "id": "Instore Executions",
    "isDeveloped": true,
    "icon": "stockInventoryConfigLogo",
    "description": "Manage inventory settings for sales reps.",
    "isActive": true,
    "isSelected": true,
    "isMandatory": true,
    "featureConfigName": "inventory",
    "role": [
      "salesrep"
    ],
    "supportedAppTypes": [
      "sfa",
      "dms"
    ],
    "subfeatures": [
      {
        "id": "Inventory",
        "isVisible": true,
        "isActive": true,
        "isMandatory": true,
        "isSelected": true,
        "isDeveloped": true,
        "domainMapping": {
          "clientconfig": [
            "store_inventory_configuration"
          ]
        },
        "appType": "standard",
        "featureConfigName": "inventory",
        "hintImage": "inventoryHintImage",
        "configuration": [
          {
            "name": "storeinventory",
            "domainType": "store_inventory_configuration",
            "uiSchema": {
              "question": "Enable Inventory?",
              "config": "json",
              "displayType": "radio",
              "validations": {}
            }
          },
          {
            "name": "inventoryTransactionVisibility",
            "domainType": "store_inventory_configuration",
            "uiSchema": {
              "question": "Show previous inventory & last date?",
              "description": "Show previous inventory quantity and the last recorded date on the inventory card.",
              "config": "json",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "copyCardData",
            "domainType": "store_inventory_configuration",
            "uiSchema": {
              "question": "Copy previous card data into new entry?",
              "description": "Pre-fill the new inventory form with values from the last entry.",
              "config": "json",
              "displayType": "toggle",
              "validations": {}
            }
          },
          {
            "name": "stockInventoryFrequency",
            "domainType": "store_inventory_configuration",
            "uiSchema": {
              "question": "Allow user to submit Stock inventory more than once?",
              "description": "Whether to allow user to submit Stock inventory once or more.",
              "config": "json",
              "displayType": "textfield",
              "validations": {}
            }
          },
          {
            "name": "stockInventoryFields",
            "domainType": "store_inventory_configuration",
            "uiSchema": {
              "question": "Inventory form fields",
              "config": "custom",
              "displayType": "table",
              "validations": {}
            }
          }
        ]
      },
      {
        "id": "Return",
        "isVisible": true,
        "isActive": true,
        "isMandatory": true,
        "isSelected": true,
        "isDeveloped": true,
        "domainMapping": {
          "clientconfig": [
            "order_return_configuration"
          ]
        },
        "appType": "standard",
        "featureConfigName": "return",
        "hintImage": "returnHintImage",
        "configuration": [
          {
            "name": "orderReturn",
            "domainType": "order_return_configuration",
            "uiSchema": {
              "question": "Show return cart inside order cart?",
              "config": "json",
              "displayType": "toggle",
              "description": "If Yes, the Return cart is shown inside the Order cart.",
              "validations": {}
            }
          },
          {
            "name": "showAddMoreButton",
            "domainType": "order_return_configuration",
            "uiSchema": {
              "question": "Show “Add more” button on return card?",
              "config": "json",
              "displayType": "toggle",
              "description": "If Yes, users can add more items to the return.",
              "validations": {}
            }
          },
          {
            "name": "displayProductMaster",
            "domainType": "order_return_configuration",
            "uiSchema": {
              "question": "Display full product catalogue in returns?",
              "config": "json",
              "displayType": "toggle",
              "description": "If Yes, show all products in the return flow.",
              "validations": {}
            }
          },
          {
            "name": "orderReturnFields",
            "domainType": "order_return_configuration",
            "uiSchema": {
              "question": "Return form fields",
              "config": "custom",
              "displayType": "table"
            }
          },
          {
            "name": "orderReturnReason",
            "domainType": "order_return_configuration",
            "uiSchema": {
              "question": "Return reasons (list)",
              "config": "custom",
              "displayType": "table"
            }
          },
          {
            "name": "submitReturnSalesData",
            "domainType": "order_return_configuration",
            "uiSchema": {
              "question": "Submit return sales data?",
              "config": "json",
              "displayType": "toggle",
              "description": "If Yes, include sales data when submitting returns.",
              "validations": {}
            }
          },
          {
            "name": "submitSalesReturnWORefNumApp",
            "domainType": "order_return_configuration",
            "uiSchema": {
              "question": "Allow submit without reference number (app)?",
              "config": "json",
              "displayType": "toggle",
              "description": "If Yes, allow submitting a sales return without a reference number.",
              "validations": {}
            }
          }
        ]
      }
    ]
  },
  {
    "id": "Incentive",
    "isDeveloped": true,
    "icon": "incentiveConfigLogo",
    "description": "Manage intelligent incentive settings for sales reps.",
    "isActive": true,
    "isSelected": true,
    "isMandatory": true,
    "featureConfigName": "incentive",
    "role": [
      "salesrep"
    ],
    "supportedAppTypes": [
      "sfa",
      "dms"
    ],
    "subfeatures": [
      {
        "id": "IntelligentIncentive",
        "isVisible": true,
        "isActive": true,
        "isMandatory": true,
        "isSelected": true,
        "isDeveloped": true,
        "domainMapping": {
          "clientconfig": [
            "incentive_configuration"
          ]
        },
        "appType": "standard",
        "featureConfigName": "intelligentincentive",
        "hintImage": "incentiveHintImage",
        "configuration": [
          {
            "name": "incentiveTabConfig",
            "domainType": "incentive_configuration",
            "uiSchema": {
              "question": "Incentive Tabs",
              "config": "custom",
              "displayType": "checkbox",
              "description": "Choose which tabs appear in the Incentive screen.",
              "validations": {
                "options": [
                  "PERIOD",
                  "DAY",
                  "LEADERBOARD"
                ]
              }
            }
          },
          {
            "name": "ruleMapping",
            "domainType": "incentive_configuration",
            "uiSchema": {
              "question": "Incentive tasks (display)",
              "editable": true,
              "config": "custom",
              "displayType": "table",
              "description": "Controls how incentive tasks appear (icon, colors, order). Higher priority = shown first."
            }
          },
          {
            "name": "incentiveLiveUpdate",
            "domainType": "incentive_configuration",
            "uiSchema": {
              "question": "Enable live updates?",
              "config": "json",
              "displayType": "toggle",
              "description": "If Yes, incentive data refreshes automatically in the app."
            }
          },
          {
            "name": "openLeaderboardOnSfaActionTab",
            "domainType": "incentive_configuration",
            "uiSchema": {
              "question": "Open Leaderboard from SFA Action tab?",
              "config": "json",
              "displayType": "toggle",
              "description": "If Yes, show the Leaderboard entry in the SFA Action tab."
            }
          },
          {
            "name": "leaderboardDesignation",
            "domainType": "incentive_configuration",
            "uiSchema": {
              "question": "Default leaderboard designation",
              "config": "json",
              "displayType": "textbox",
              "description": "Designation to load by default on the Leaderboard (e.g., dse)."
            }
          },
          {
            "name": "incentiveFaq",
            "domainType": "incentive_configuration",
            "uiSchema": {
              "question": "Incentive FAQs",
              "config": "custom",
              "displayType": "table",
              "description": "User can share FAQs if enabled."
            }
          },
          {
            "name": "showIncentivePopup",
            "domainType": "incentive_configuration",
            "uiSchema": {
              "question": "Show Incentive popups?",
              "config": "json",
              "displayType": "toggle",
              "description": "If Yes, show pop up of left incentive points."
            }
          },
          {
            "name": "incentiveDuration",
            "domainType": "incentive_configuration",
            "uiSchema": {
              "question": "Incentive Duration?",
              "config": "json",
              "displayType": "select",
              "description": "Show incentive duration.",
              "validations": {
                "options": [
                  "MONTH",
                  "PERIOD",
                  "WEEKLY"
                ]
              }
            }
          },
          {
            "name": "incentiveCalculationType",
            "domainType": "incentive_configuration",
            "uiSchema": {
              "question": "Select Incentive Calculation type",
              "config": "json",
              "displayType": "select",
              "description": "User can select if incentive is to be calculated on sales or order.",
              "validations": {
                "options": [
                  "SALES",
                  "ORDER"
                ]
              }
            }
          }
        ]
      }
    ]
  }
]
// export const featureConfiguration = [
//      {
//         "id": "App essentials",
//         "isDeveloped": true,
//         "icon": "projectConfigLogo",
//         "description": " Setup the foundations of your app like timezone, dial code, currency & support no.",
//         "isActive": true,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "displayTemplateTwo": true,
//         "role": [
//             "salesrep",
//             "retailer"
//         ],
//         "appType": "standard",
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ],
//         "subfeatures":[
//             {
//         "id": "Project",
//         "isDeveloped": true,
//         "featureConfigName": "project",
//         "isActive": true,
//         "isSelected": true,
//         "isMandatory": true,
//         "domainMapping":{
//             "clientConfig":["project_configuration","customer_configuration"]
//         },
//         "hintImage": "kpiHintImage",
//         "displayTemplateTwo": true,
//         "role": [
//             "salesrep",
//             "retailer"
//         ],
//         "appType": "standard",
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ],
//         "configuration":[
//   {
//     "name": "countryCode",
//     "value": "AM",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Enter country code",
//       "config": "custom",
//       "displayType": "select",
//       "editable": true,
//       "validations": [],
    
//     }
//   },
//   {
//     "name": "dialCode",
//     "value": "374",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Enter dial code",
//       "config": "custom",
//       "displayType": "select",
//       "editable": false,
//       "validations": []
//     }
//   },
//   {
//     "name": "clientTimeZone",
//     "value": "Asia/Yerevan",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Select client timezone",
//       "config": "custom",
//       "displayType": "select",
//       "editable": true,
//       "validations": []
//     }
//   },
//   {
//     "name": "currencySymbol",
//     "value": "֏",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Enter currency symbol",
//       "config": "custom",
//       "displayType": "select",
//       "editable": true,
//       "validations": []
//     }
//   },
//   {
//     "name": "currency",
//     "value": "₹",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Enter currency",
//       "config": "custom",
//       "displayType": "textField",
//       "editable": false,
//       "validations": []
//     }
//   },
//   {
//     "name": "supportNumber",
//     "value": "123123123118",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Enter support number",
//       "config": "json",
//       "displayType": "textField",
//       "editable": true,
//       "validations": ["^.{10,15}$"]
//     }
//   },
//   {
//     "name": "externalAppDeepLink",
//     "value": "test.com",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Enter deep link",
//       "config": "json",
//       "displayType": "textField",
//       "editable": true,
//       "validations": []
//     }
//   },
//   {
//     "name": "chatGptEnabled",
//     "value": true,
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "boolean",
//       "question": "Enable ChatGPT?",
//       "config": "json",
//       "displayType": "checkbox",
//       "editable": true,
//       "validations": []
//     }
//   },
//   {
//     "name": "clientHeaderLogoHeight",
//     "value": "",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Enter header logo height",
//       "config": "json",
//       "displayType": "textField",
//       "editable": true,
//       "validations": ["^[1-9]\\d*$"]
//     }
//   }
// ]
       
// },
//     {
//         "id": "ProjectNonStandard",
//         "isDeveloped": true,
//         "featureConfigName": "project",
//          "domainMapping":{
//            "clientConfig":["project_configuration","customer_configuration"]
//         },
//         "isActive": true,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "displayTemplateTwo": true,
//         "role": [
//             "salesrep",
//             "retailer"
//         ],
//         "appType": "nonstandard",
//         "label": "Project",
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ],
//           "configuration":[
//   {
//     "name": "countryCode",
//     "value": "AM",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Enter country code",
//       "config": "custom",
//       "displayType": "select",
//       "editable": true,
//       "validations": [],
    
//     }
//   },
//   {
//     "name": "dialCode",
//     "value": "374",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Enter dial code",
//       "config": "custom",
//       "displayType": "select",
//       "editable": false,
//       "validations": []
//     }
//   },
//   {
//     "name": "clientTimeZone",
//     "value": "Asia/Yerevan",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Select client timezone",
//       "config": "custom",
//       "displayType": "select",
//       "editable": true,
//       "validations": []
//     }
//   },
//   {
//     "name": "currencySymbol",
//     "value": "֏",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Enter currency symbol",
//       "config": "custom",
//       "displayType": "select",
//       "editable": true,
//       "validations": []
//     }
//   },
//   {
//     "name": "currency",
//     "value": "₹",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Enter currency",
//       "config": "custom",
//       "displayType": "textField",
//       "editable": false,
//       "validations": []
//     }
//   },
//   {
//     "name": "supportNumber",
//     "value": "123123123118",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Enter support number",
//       "config": "json",
//       "displayType": "textField",
//       "editable": true,
//       "validations": ["^.{10,15}$"]
//     }
//   },
//   {
//     "name": "externalAppDeepLink",
//     "value": "test.com",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Enter deep link",
//       "config": "json",
//       "displayType": "textField",
//       "editable": true,
//       "validations": []
//     }
//   },
//   {
//     "name": "chatGptEnabled",
//     "value": true,
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "boolean",
//       "question": "Enable ChatGPT?",
//       "config": "json",
//       "displayType": "checkbox",
//       "editable": true,
//       "validations": []
//     }
//   },
//   {
//     "name": "clientHeaderLogoHeight",
//     "value": "",
//     "domainType": "customer_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Enter header logo height",
//       "config": "json",
//       "displayType": "textField",
//       "editable": true,
//       "validations": ["^[1-9]\\d*$"]
//     }
//   }
// ]
//     },
//     {
//         "id": "AppNonStandard",
//         "isDeveloped": true,
//         "icon": "uiThemeConfigLogo",
//         "featureConfigName": "app",
//         "isActive": false,
//          "domainMapping":{
//             "clientConfig":["app_configuration","theme_configuration"]
//         },
//         "isSelected": true,
//         "isMandatory": true,
       
//         "hintImage": "kpiHintImage",
//         "displayTemplateTwo": true,
//         "role": [
//             "salesrep",
//             "retailer"
//         ],
//         "appType": "nonstandard",
//         "label": "App",
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ],
//         "configurations":[

//         ],   
//     },
//     {
//         "id": "UI and Theme",
//         "isDeveloped": true,
//         "featureConfigName": "uiandtheme",
//         "icon": "uiThemeConfigLogo",
//         "domainMapping":{
//             "clientConfig":["app_configuration","theme_configuration","ui_and_theme_configuration"]
//         },
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "displayTemplateTwo": true,
//         "role": [
//             "salesrep",
//             "retailer"
//         ],
//         "appType": "standard",
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ],
//         "configurations":[
//   {
//     "name": "clientHeaderLogo",
//     "value": "",
//     "domainType": "ui_and_theme_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Upload client header logo",
//       "config": "json",
//       "displayType": "image",
//       "editable": true,
//       "validations": []
//     }
//   },
//   {
//     "name": "clientHeaderLogoHeight",
//     "value": 40,
//     "domainType": "ui_and_theme_configuration",
//     "uiSchema": {
//       "type": "number",
//       "question": "Enter logo height (px)",
//       "config": "json",
//       "displayType": "textField",
//       "editable": true,
//       "validations": ["^[1-9]\\d*$"]
//     }
//   },
//   {
//     "name": "themeColor",
//     "value": "227c9d",
//     "domainType":"ui_and_theme_configuration",
//     "uiSchema": {
//       "type": "string",
//       "question": "Select theme color",
//       "config": "json",
//       "displayType": "colorInput",
//       "editable": true,
//       "validations": ["^#?([0-9a-fA-F]{6})$"]
//     }
//   }
// ]     
//     },

//         ]
//     },
    
//     {
//         "id": "Multi Language Interface",
//         "icon": "bannerConfigLogo",
//         "description": "Displays promotional banners throughout the application.",
//         "featureConfigName": "multilanguageinterface",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "role": [
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Login",
//         "isDeveloped": true,
//         "icon": "loginConfigLogo",
//         "description": "Manage the login config",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "login",
//         "role": [
//             "salesrep",
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//         "subfeatures":[
            
//         ]
//     },
//     {
//         "id": "Password",
//         "isDeveloped": true,
//         "icon": "loginConfigLogo",
//         "description": "Manage the password config",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "password",
//         "role": [
//             "salesrep",
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Recommendation",
//         "icon": "recommendationConfigLogo",
//         "description": "Provides recommendations based on user behavior.",
//         "isActive": false,
//         "isSelected": false,
//         "isMandatory": false,
//         "hintImage": "recomendationImage",
//         "featureConfigName": "recommendation",
//         "addTemplate": true,
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Must Do Action",
//         "isDeveloped": true,
//         "icon": "teleOrderConfigLogo",
//         "description": "Manage the sequence and messaging of must do task.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "teleOrderImage",
//         "featureConfigName": "mustdoaction",
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "KPI Review",
//         "isDeveloped": true,
//         "icon": "kpiConfigLogo",
//         "description": "Select and modify KPIs you want to show to your Sales team.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "kpi",
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Attendance",
//         "icon": "attendanceConfigLogo",
//         "description": "Manages user attendance records.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "attendance",
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Outlet Tile",
//         "icon": "outletTaskTileConfigLogo",
//         "description": "Displays tasks associated with outlets in a tile format.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "outlettile",
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Outlet Profile",
//         "icon": "outletProfileConfigLogo",
//         "description": "Shows detailed profiles of outlets.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "outletprofile",
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Search Functionality",
//         "icon": "checkoutConfigLogo",
//         "description": "Manage what the user sees before order submission.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "searchfunctionality",
//         "role": [
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Catalogue",
//         "isDeveloped": true,
//         "icon": "catalogueConfigLogo",
//         "description": "Manage the product catalogue to make the ordering process more efficient.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "featureConfigName": "catalogue",
//         "hintImage": "kpiHintImage",
//         "role": [
//             "salesrep",
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Visit Order",
//         "icon": "visitOrderConfigLogo",
//         "description": "Manages orders related to user visits.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "visitorder",
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Cart",
//         "isDeveloped": true,
//         "icon": "cartConfigLogo",
//         "description": "Manage the cart before moving to order submission.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "cart",
//         "role": [
//             "salesrep",
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "One Click Order",
//         "icon": "oneClickOrderConfigLogo",
//         "description": "Enables users to place orders with a single click.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "oneclickorder",
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Remote Order",
//         "icon": "remoteOrderConfigLogo",
//         "description": "Handles orders placed remotely by users.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "remoteorder",
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Tele Order",
//         "icon": "teleOrderConfigLogo",
//         "description": "Handles orders placed via telephone.",
//         "isActive": false,
//         "isSelected": false,
//         "isMandatory": false,
//         "hintImage": "teleOrderImage",
//         "featureConfigName": "teleOrder",
//         "additionalActivationConfigurations": [
//             {
//                 "domainType": "app_layout_configuration",
//                 "domainValues": [
//                     {
//                         "name": "outletTileOptions",
//                         "type": "List",
//                         "value": [
//                             {
//                                 "id": "Tele Order",
//                                 "svgPath": "assets/svg/teleOrder.svg"
//                             },
//                             {
//                                 "id": "Remote Order",
//                                 "svgPath": "assets/svg/myRemoteOrder.svg"
//                             },
//                             {
//                                 "id": "Visit Order",
//                                 "svgPath": "assets/svg/visitOrder.svg"
//                             }
//                         ],
//                         "customHandler": {
//                             "added": {
//                                 "function": "appendInTileOptions",
//                                 "customValue": [
//                                     {
//                                         "id": "Tele Order",
//                                         "svgPath": "assets/svg/teleOrder.svg"
//                                     }
//                                 ]
//                             },
//                             "removed": {
//                                 "function": "removeFromTileOptions",
//                                 "identificationField": "id",
//                                 "customValue": [
//                                     {
//                                         "id": "Tele Order",
//                                         "svgPath": "assets/svg/teleOrder.svg"
//                                     }
//                                 ]
//                             }
//                         },
//                         "docUrl": "",
//                         "description": "Outlet tile options",
//                         "possibleVals": []
//                     }
//                 ]
//             }
//         ],
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Order Summary",
//         "isDeveloped": true,
//         "icon": "checkoutConfigLogo",
//         "description": "Manage what the user sees before order submission.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "ordersummary",
//         "role": [
//             "salesrep",
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Order Feedback",
//         "icon": "orderFeedbackConfigLogo",
//         "description": "Gathers feedback from users about their orders.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "orderfeedback",
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Order Tracking",
//         "isDeveloped": true,
//         "icon": "orderTrackingConfigLogo",
//         "description": "Manage how the user can review  and track the orders.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "ordertracking",
//         "role": [
//             "salesrep",
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Store In/Out",
//         "icon": "storeInOutConfigLogo",
//         "description": "Tracks inventory for store in and out operations.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "storeinout",
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Return",
//         "icon": "stockInventoryConfigLogo",
//         "description": "Manages and tracks stock inventory levels.",
//         "isActive": false,
//         "isSelected": false,
//         "isMandatory": false,
//         "hintImage": "stockInventoryImage",
//         "featureConfigName": "stockReturn",
//         "additionalActivationConfigurations": [
//             {
//                 "domainType": "app_layout_configuration",
//                 "domainValues": [
//                     {
//                         "name": "outletActivityTabs",
//                         "type": "list",
//                         "value": [
//                             {
//                                 "id": "storeReturn",
//                                 "label": "STOCK RETURN",
//                                 "iconPath": "assets/svg/stock_returns.svg",
//                                 "isDefault": true,
//                                 "themeColor": "#7f7398",
//                                 "storeInRequired": ""
//                             }
//                         ],
//                         "description": "temp",
//                         "defaultValue": "[]",
//                         "possibleVals": [
//                             []
//                         ],
//                         "customHandler": {
//                             "added": {
//                                 "function": "updateTabList",
//                                 "identificationField": "id"
//                             },
//                             "removed": {
//                                 "function": "removeTab",
//                                 "identificationField": "id"
//                             }
//                         }
//                     }
//                 ]
//             },
//             {
//                 "domainType": "order_return_configuration",
//                 "domainValues": [
//                     {
//                         "name": "orderReturnFields",
//                         "type": "List",
//                         "value": [
//                             {
//                                 "id": "returnReason",
//                                 "type": "dropDown",
//                                 "label": "Reason",
//                                 "validation": {}
//                             },
//                             {
//                                 "id": "returnQtyPC",
//                                 "type": "textField",
//                                 "label": "Return Qty (PC)",
//                                 "validation": {}
//                             }
//                         ]
//                     },
//                     {
//                         "name": "orderReturnReason",
//                         "type": "List",
//                         "value": [
//                             {
//                                 "id": "1",
//                                 "reason": "Maximum freshness"
//                             },
//                             {
//                                 "id": "9",
//                                 "reason": "Striked"
//                             },
//                             {
//                                 "id": "10",
//                                 "reason": "Damaged label"
//                             },
//                             {
//                                 "id": "11",
//                                 "reason": "Dirty"
//                             },
//                             {
//                                 "id": "12",
//                                 "reason": "Closed bursts"
//                             },
//                             {
//                                 "id": "13",
//                                 "reason": "Empty - Bottle base cracks"
//                             },
//                             {
//                                 "id": "14",
//                                 "reason": "Low level"
//                             },
//                             {
//                                 "id": "15",
//                                 "reason": "Bottle cap unclosed"
//                             },
//                             {
//                                 "id": "16",
//                                 "reason": "Internal dirt/Foreign Matter - Closed"
//                             },
//                             {
//                                 "id": "17",
//                                 "reason": "Soft Bottle Closed"
//                             },
//                             {
//                                 "id": "18",
//                                 "reason": "Bottle Deformation"
//                             },
//                             {
//                                 "id": "19",
//                                 "reason": "Stress Leakage Shoulders / Finish"
//                             }
//                         ],
//                         "docUrl": "",
//                         "description": "return reason in stock return",
//                         "possibleVals": []
//                     },
//                     {
//                         "name": "orderReturn",
//                         "type": "boolean",
//                         "value": true,
//                         "docUrl": "",
//                         "description": "Whether to show return cart page inside order cart page",
//                         "possibleVals": [
//                             true,
//                             false
//                         ]
//                     }
//                 ]
//             }
//         ],
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Inventory",
//         "icon": "stockInventoryConfigLogo",
//         "description": "Manages and tracks stock inventory levels.",
//         "isActive": false,
//         "isSelected": false,
//         "isMandatory": false,
//         "hintImage": "stockInventoryImage",
//         "featureConfigName": "stockInventory",
//         "additionalActivationConfigurations": [
//             {
//                 "domainType": "app_layout_configuration",
//                 "domainValues": [
//                     {
//                         "name": "outletActivityTabs",
//                         "type": "list",
//                         "value": [
//                             {
//                                 "id": "storeInventory",
//                                 "label": "STOCK INVENTORY",
//                                 "iconPath": "assets/svg/store_inventory.svg",
//                                 "isDefault": true,
//                                 "themeColor": "#32a785",
//                                 "storeInRequired": ""
//                             }
//                         ],
//                         "description": "temp",
//                         "defaultValue": "[]",
//                         "possibleVals": [
//                             []
//                         ],
//                         "customHandler": {
//                             "added": {
//                                 "function": "updateTabList",
//                                 "identificationField": "id"
//                             },
//                             "removed": {
//                                 "function": "removeTab",
//                                 "identificationField": "id"
//                             }
//                         }
//                     }
//                 ]
//             },
//             {
//                 "domainType": "store_inventory_configuration",
//                 "domainValues": [
//                     {
//                         "name": "inventoryTransactionVisibility",
//                         "type": "boolean",
//                         "value": true,
//                         "description": "Whether to show previous inventory qty and  last inventory date in store inventory card",
//                         "possibleVals": [
//                             true,
//                             false
//                         ]
//                     },
//                     {
//                         "name": "copyCardData",
//                         "type": "boolean",
//                         "value": true,
//                         "description": "Whether to copy previous inventory card data or not",
//                         "possibleVals": [
//                             true,
//                             false
//                         ]
//                     }
//                 ]
//             }
//         ],
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Merchandising",
//         "icon": "merchandisingConfigLogo",
//         "description": "Handles merchandising strategies and displays.",
//         "isActive": false,
//         "isSelected": false,
//         "isMandatory": false,
//         "hintImage": "merchandisingImage",
//         "featureConfigName": "merchandising",
//         "additionalActivationConfigurations": [
//             {
//                 "domainType": "app_layout_configuration",
//                 "domainValues": [
//                     {
//                         "name": "outletActivityTabs",
//                         "type": "list",
//                         "value": [
//                             {
//                                 "id": "merchandising",
//                                 "label": "MERCHANDISING",
//                                 "iconPath": "assets/svg/merchandising.svg",
//                                 "isDefault": false,
//                                 "themeColor": "#767bfe",
//                                 "storeInRequired": ""
//                             }
//                         ],
//                         "description": "temp",
//                         "defaultValue": "[]",
//                         "possibleVals": [
//                             []
//                         ],
//                         "customHandler": {
//                             "added": {
//                                 "function": "updateTabList",
//                                 "identificationField": "id"
//                             },
//                             "removed": {
//                                 "function": "removeTab",
//                                 "identificationField": "id"
//                             }
//                         }
//                     }
//                 ]
//             },
//             {
//                 "domainType": "app_options_configuration",
//                 "domainValues": [
//                     {
//                         "name": "merchandisingOption",
//                         "type": "list",
//                         "value": [
//                             "Merchandising 1",
//                             "Merchandising 2",
//                             "Merchandising 3"
//                         ],
//                         "description": "temp",
//                         "defaultValue": [],
//                         "possibleVals": [
//                             []
//                         ]
//                     }
//                 ]
//             }
//         ],
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Competition Tracking",
//         "icon": "competitionTrackingConfigLogo",
//         "description": "Tracks competitions and their results.",
//         "isActive": false,
//         "isSelected": false,
//         "isMandatory": false,
//         "hintImage": "competetionTrackingImage",
//         "featureConfigName": "competitionTracking",
//         "additionalActivationConfigurations": [
//             {
//                 "domainType": "app_layout_configuration",
//                 "domainValues": [
//                     {
//                         "name": "outletActivityTabs",
//                         "type": "list",
//                         "value": [
//                             {
//                                 "id": "competitionTracking",
//                                 "label": "COMPETITION TRACKING",
//                                 "iconPath": "assets/svg/competition_tracking.svg",
//                                 "isDefault": true,
//                                 "themeColor": "#e1ad01",
//                                 "storeInRequired": ""
//                             }
//                         ],
//                         "description": "temp",
//                         "defaultValue": "[]",
//                         "possibleVals": [
//                             []
//                         ],
//                         "customHandler": {
//                             "added": {
//                                 "function": "updateTabList",
//                                 "identificationField": "id"
//                             },
//                             "removed": {
//                                 "function": "removeTab",
//                                 "identificationField": "id"
//                             }
//                         }
//                     }
//                 ]
//             },
//             {
//                 "domainType": "app_options_configuration",
//                 "domainValues": [
//                     {
//                         "name": "competitorOption",
//                         "type": "list",
//                         "value": [
//                             "Competitor 1",
//                             "Competitor 2",
//                             "Competitor 3"
//                         ],
//                         "description": "temp",
//                         "defaultValue": [],
//                         "possibleVals": [
//                             []
//                         ]
//                     },
//                     {
//                         "name": "activityOption",
//                         "type": "list",
//                         "value": [
//                             "Activity 1",
//                             "Activity 2",
//                             "Activity 3"
//                         ],
//                         "description": "temp",
//                         "defaultValue": [],
//                         "possibleVals": [
//                             []
//                         ]
//                     }
//                 ]
//             }
//         ],
//         "role": [
//             "salesrep"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Basket",
//         "icon": "bannerConfigLogo",
//         "description": "Displays promotional banners throughout the application.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "basket",
//         "role": [
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Profile",
//         "icon": "bannerConfigLogo",
//         "description": "Displays promotional banners throughout the application.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "profile",
//         "role": [
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Bucket",
//         "icon": "bannerConfigLogo",
//         "description": "Displays promotional banners throughout the application.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "bucket",
//         "role": [
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Banner",
//         "icon": "bannerConfigLogo",
//         "description": "Displays promotional banners throughout the application.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "banner",
//         "role": [
//             "salesrep",
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Scheme Module",
//         "icon": "checkoutConfigLogo",
//         "description": "Manage what the user sees before order submission.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "schemeproduct",
//         "role": [
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Order Edit/Cancellation",
//         "icon": "checkoutConfigLogo",
//         "description": "Manage what the user sees before order submission.",
//         "isActive": false,
//         "isSelected": false,
//         "isMandatory": false,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "ordercancellation",
//         "additionalActivationConfigurations": [
//             {
//                 "domainType": "order_configuration",
//                 "domainValues": [
//                     {
//                         "name": "orderCancellation",
//                         "type": "boolean",
//                         "value": true,
//                         "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
//                         "description": "To allow order cancellation",
//                         "defaultValue": false,
//                         "possibleVals": [
//                             true,
//                             false
//                         ]
//                     },
//                     {
//                         "name": "orderCancellationCardColor",
//                         "type": "string",
//                         "value": "#2bbbad",
//                         "docUrl": "",
//                         "description": "order cancellation card color",
//                         "defaultValue": "#2bbbad",
//                         "possibleVals": [
//                             "#2bbbad"
//                         ]
//                     },
//                     {
//                         "name": "orderCancellationPeriod",
//                         "type": "number",
//                         "value": 180,
//                         "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
//                         "description": "Time (in secs) within which the order can be cancelled",
//                         "defaultValue": 0,
//                         "possibleVals": []
//                     },
//                     {
//                         "name": "orderCancellationReasons",
//                         "type": "list",
//                         "value": [
//                             "I have ordered the products through Salesman.",
//                             "I ordered wrong product(s).",
//                             "I ordered wrong quantity.",
//                             "I got better rates elsewhere.",
//                             "Other reasons."
//                         ],
//                         "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
//                         "description": "Reasons for order cancellation. We'll restrict that 5 reasons can be added at max.",
//                         "defaultValue": [
//                             "I have ordered the products through Salesman.",
//                             "I ordered wrong product(s).",
//                             "I ordered wrong quantity.",
//                             "I got better rates elsewhere.",
//                             "Other reasons."
//                         ],
//                         "possibleVals": []
//                     },
//                     {
//                         "name": "orderCancellationDisclaimer",
//                         "type": "String",
//                         "value": "Before you cancel, please let us know the reason to help us improve our services",
//                         "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
//                         "description": "Order Cancel Disclaimer",
//                         "defaultValue": "Before you cancel, please let us know the reason to help us improve our services",
//                         "possibleVals": []
//                     },
//                     {
//                         "name": "orderCancellationSummaryDisclaimer",
//                         "type": "String",
//                         "value": "Hi there! I have cancelled your order as per request.",
//                         "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
//                         "description": "Order Cancel Disclaimer",
//                         "defaultValue": "Hi there! I have cancelled your order as per request.",
//                         "possibleVals": []
//                     }
//                 ]
//             }
//         ],
//         "role": [
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Order Ledger",
//         "icon": "checkoutConfigLogo",
//         "description": "Manage what the user sees before order submission.",
//         "isActive": false,
//         "isSelected": false,
//         "isMandatory": false,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "orderledger",
//         "additionalActivationConfigurations": [
//             {
//                 "domainType": "order_configuration",
//                 "domainValues": [
//                     {
//                         "name": "orderSourceVisibility",
//                         "type": "boolean",
//                         "value": true,
//                         "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
//                         "description": "To order source visible.",
//                         "defaultValue": true,
//                         "possibleVals": [
//                             true,
//                             false
//                         ]
//                     }
//                 ]
//             }
//         ],
//         "role": [
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Invoice Ledger",
//         "icon": "checkoutConfigLogo",
//         "description": "Manage what the user sees before order submission.",
//         "isActive": false,
//         "isSelected": false,
//         "isMandatory": false,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "invoice",
//         "additionalActivationConfigurations": [
//             {
//                 "domainType": "app_layout_configuration",
//                 "domainValues": [
//                     {
//                         "name": "morePageWidget",
//                         "type": "list",
//                         "value": [
//                             {
//                                 "name": "InvoiceTracking",
//                                 "type": "moreOptions",
//                                 "image": "assets/svg/Invoice.svg",
//                                 "label": "Invoice Details"
//                             }
//                         ],
//                         "customHandler": {
//                             "added": {
//                                 "function": "updateTabList",
//                                 "identificationField": "name"
//                             },
//                             "removed": {
//                                 "function": "removeTab",
//                                 "identificationField": "name"
//                             }
//                         }
//                     }
//                 ]
//             }
//         ],
//         "role": [
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Purchase Summary",
//         "icon": "checkoutConfigLogo",
//         "description": "Manage what the user sees before order submission.",
//         "isActive": false,
//         "isSelected": false,
//         "isMandatory": false,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "purchasesummary",
//         "additionalActivationConfigurations": [
//             {
//                 "domainType": "app_layout_configuration",
//                 "domainValues": [
//                     {
//                         "name": "morePageWidget",
//                         "type": "list",
//                         "value": [
//                             {
//                                 "name": "Purchase Summary",
//                                 "type": "moreOptions",
//                                 "image": "assets/svg/purchase_summary.svg",
//                                 "label": "Purchase Summary"
//                             }
//                         ],
//                         "customHandler": {
//                             "added": {
//                                 "function": "updateTabList",
//                                 "identificationField": "name"
//                             },
//                             "removed": {
//                                 "function": "removeTab",
//                                 "identificationField": "name"
//                             }
//                         }
//                     }
//                 ]
//             },
//             {
//                 "domainType": "app_options_configuration",
//                 "domainValues": [
//                     {
//                         "name": "purchaseSummaryDataSorting",
//                         "type": "boolean",
//                         "value": true,
//                         "docUrl": "",
//                         "description": "Purchase summary data sorting",
//                         "possibleVals": [
//                             "true",
//                             "false"
//                         ]
//                     },
//                     {
//                         "name": "purchaseSummaryHeaderConfig",
//                         "type": "list",
//                         "value": [
//                             {
//                                 "id": "bill_value",
//                                 "label": "Bill Value",
//                                 "barChart": true,
//                                 "imagePath": "bill_value.svg",
//                                 "lineChart": false,
//                                 "currencyIcon": true,
//                                 "showTrendChart": true,
//                                 "chartDisclaimer": true,
//                                 "decimalConvert": true
//                             },
//                             {
//                                 "id": "total_earning",
//                                 "label": "Total Earning",
//                                 "barChart": true,
//                                 "imagePath": "total_earning.svg",
//                                 "lineChart": false,
//                                 "currencyIcon": true,
//                                 "showTrendChart": true,
//                                 "chartDisclaimer": true,
//                                 "decimalConvert": true
//                             },
//                             {
//                                 "id": "number_of_bills",
//                                 "label": "Number of Bills",
//                                 "barChart": false,
//                                 "imagePath": "number_of_bills.svg",
//                                 "lineChart": true,
//                                 "currencyIcon": false,
//                                 "showTrendChart": true,
//                                 "chartDisclaimer": true,
//                                 "showingTooltipOnSpots": [],
//                                 "decimalConvert": false
//                             },
//                             {
//                                 "id": "number_of_packs",
//                                 "label": "Packs Purchased",
//                                 "barChart": false,
//                                 "imagePath": "pack_purchased.svg",
//                                 "lineChart": true,
//                                 "currencyIcon": false,
//                                 "showTrendChart": true,
//                                 "chartDisclaimer": true,
//                                 "showingTooltipOnSpots": [],
//                                 "decimalConvert": false
//                             },
//                             {
//                                 "id": "total_quantity",
//                                 "label": "Total Quantity",
//                                 "barChart": false,
//                                 "imagePath": "total_quqntity.svg",
//                                 "lineChart": false,
//                                 "currencyIcon": false,
//                                 "QtyDisplayList": [
//                                     {
//                                         "key": "total_case_quantity",
//                                         "label": "cs"
//                                     },
//                                     {
//                                         "key": "total_piece_quantity",
//                                         "label": "pcs"
//                                     }
//                                 ],
//                                 "showTrendChart": false,
//                                 "chartDisclaimer": false,
//                                 "decimalConvert": false
//                             }
//                         ],
//                         "description": "Purchase Tiles",
//                         "possibleVals": [
//                             "true",
//                             "false"
//                         ]
//                     }
//                 ]
//             }
//         ],
//         "role": [
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Support",
//         "icon": "supportConfigLogo",
//         "description": "Provides support options for users.",
//         "featureConfigName": "support",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "hintImage": "kpiHintImage",
//         "role": [
//             "salesrep",
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Order Status Push Notification",
//         "icon": "checkoutConfigLogo",
//         "description": "Manage what the user sees before order submission.",
//         "isActive": false,
//         "isSelected": true,
//         "isMandatory": true,
//         "featureConfigName": "orderstatuspushnotification",
//         "hintImage": "kpiHintImage",
//         "role": [
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     },
//     {
//         "id": "Locate Me",
//         "icon": "checkoutConfigLogo",
//         "description": "Manage what the user sees before order submission.",
//         "isActive": false,
//         "isSelected": false,
//         "isMandatory": false,
//         "hintImage": "kpiHintImage",
//         "featureConfigName": "locateme",
//         "additionalActivationConfigurations": [
//             {
//                 "domainType": "app_layout_configuration",
//                 "domainValues": [
//                     {
//                         "name": "morePageWidget",
//                         "type": "list",
//                         "value": [
//                             {
//                                 "name": "locateMe",
//                                 "type": "moreOptions",
//                                 "image": "assets/svg/locate_me.svg",
//                                 "label": "Locate Me"
//                             }
//                         ],
//                         "customHandler": {
//                             "added": {
//                                 "function": "updateTabList",
//                                 "identificationField": "name"
//                             },
//                             "removed": {
//                                 "function": "removeTab",
//                                 "identificationField": "name"
//                             }
//                         }
//                     }
//                 ]
//             },
//             {
//                 "domainType": "app_configuration",
//                 "domainValues": [
//                     {
//                         "name": "locationPopup",
//                         "type": "boolean",
//                         "value": true,
//                         "docUrl": "",
//                         "domainType": "app_configuration",
//                         "description": "Show android location permission popup when the home screen load first time",
//                         "possibleVals": []
//                     },
//                     {
//                         "name": "locationPopupOnOrder",
//                         "type": "boolean",
//                         "value": true,
//                         "docUrl": "",
//                         "domainType": "app_configuration",
//                         "description": "Show android location permission popup when the home screen load first time",
//                         "possibleVals": []
//                     }
//                 ]
//             }
//         ],
//         "role": [
//             "retailer"
//         ],
//         "supportedAppTypes": [
//             "sfa",
//             "eb2b",
//             "dms"
//         ]
//     }
// ];
